module.exports = __webpack_public_path__ + "064306a6545481cf4a44767626b644c0.jpg";